import type {
    CustomerReviewPayload,
    CustomerReviewResponse,
} from '@/types/apps/customer-review.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

export interface CustomerReviewServiceInterface {}

type CustomerReviewListResponse = ApiResponse<
    PaginatedResult<CustomerReviewResponse>
>;

export class CustomerReviewService
    implements Showable, Updatable, Deletable, Creatable, Indexable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/CustomerReviews',
        detail: (id: string) => `/api/CustomerReviews/${id}`,
    };

    public index(params?: QueryParams): Promise<CustomerReviewListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<CustomerReviewResponse>> {
        const url = this.endpoints.detail(id);

        return this.apiClient.fetchApi(url, params);
    }

    public create(
        payload: CustomerReviewPayload
    ): Promise<ApiResponse<CustomerReviewResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }

    public update(
        id: string,
        payload: CustomerReviewPayload
    ): Promise<ApiResponse<CustomerReviewResponse>> {
        return this.apiClient.putApi(this.endpoints.detail(id), payload);
    }
    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        const url = this.endpoints.base();

        return this.apiClient.destroyApi<void>(url, ids, isHardDeleted);
    }
}
